













































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateConstitute from "./create-constitute.vue";
import EditConstitute from "./edit-constitute.vue";
import Ajax from "../../lib/ajax";
import RegionSelect from "../../components/region-select.vue";
class PageConstituteRequest extends PageRequest {
  name: string;
  isBack: boolean = true;
}

@Component({
  components: { CreateConstitute, EditConstitute, RegionSelect },
})
export default class Constitutes extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageConstituteRequest = new PageConstituteRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  regions = [];

  get list() {
    return this.$store.state.constitute.list;
  }
  get loading() {
    return this.$store.state.constitute.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("constitute/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("constitute/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("constitute/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "constitute/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.constitute.pageSize;
  }
  get totalCount() {
    return this.$store.state.constitute.totalCount;
  }
  get currentPage() {
    return this.$store.state.constitute.currentPage;
  }
  updateDisplayOrder(row) {
    Ajax.put("/api/services/app/Constitute/UpdateDisplayOrder", {
      id: row.id,
      displayOrder: row.displayOrder,
    });
  }
  columns = [
    {
      title: this.L("ConstituteName"),
      key: "name",
      tooltip: true,
    },
     {
      title: '球数(几球)',
      key: "ballNumber",
      width:80,
      align:"center"
      
    },
    {
      title: "供应商",
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.supplier && params.row.supplier.name
            ? params.row.supplier.name
            : "暂无"
        );
      },
    },
    {
      title: this.L("StartDate"),
      key: "startDate",
      width: 120,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.startDate).toLocaleDateString());
      },
    },
    {
      title: this.L("EndDate"),
      key: "endDate",
      width: 120,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.endDate).toLocaleDateString());
      },
    },
    {
      title: this.L("OrderDays"),
      key: "days",
      width: 120,
    },
    {
      title: this.L("Price"),
      key: "advanceCharge",
      width: 120,
      render: (h: any, params: any) => {
        return h(
          "span",
          this.L("CurrencyIcon") + params.row.advanceCharge.toFixed(2)
        );
      },
    },
    {
      title: this.L("DisplayOrder"),
      key: "displayOrder",
      width: 70,
      slot: "displayOrder",
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      align: "center",
      render: (h, params) => {
        const hasEditPermission = this.hasPermission("Pages.Constitute.Edit");
        const hasDeletePermission = this.hasPermission(
          "Pages.Constitute.Delete"
        );
        const buttons = [];
        if (hasEditPermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.$store.commit("constitute/edit", params.row);
                    this.edit();
                  },
                },
              },
              this.L("Edit")
            )
          );
        }

        if (hasDeletePermission && !params.row.isStatic) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                  disabled: params.row.isStatic,
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: this.L("ConstituteDeleteWarningMessage"),
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "constitute/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              this.L("Delete")
            )
          );
        }
        return h("div", buttons);
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
